//Mixins
import { AjaxMixin } from "./mixins/AjaxMixin";
import { HelpersMixin } from "./mixins/HelpersMixin";
import { ValidationMixin } from "./mixins/ValidationMixin";
import { LocalisedVarsMixin } from "./mixins/LocalisedVarsMixin";
import { RecaptchaMixin } from "./mixins/RecaptchaMixin";
//Components
import BxpFormFramework from "./components/BxpFormFramework";
import BxpLoadingScreen from "./components/BxpLoadingScreen";
import BxpLoadingText from "./components/BxpLoadingText";
import BxpButton from "./components/BxpButton";
import BxpExpansionPane from "./components/BxpExpansionPane";
import BxpBackToTop from "./components/BxpBackToTop";

export default {

  install( Vue, options ) {

    Vue.component('bxp-form-framework', BxpFormFramework);
    Vue.component('bxp-loading-screen', BxpLoadingScreen);
    Vue.component('bxp-loading-text', BxpLoadingText);
    Vue.component('bxp-button', BxpButton);
    Vue.component('bxp-expansion-pane', BxpExpansionPane);
    Vue.component('bxp-back-to-top', BxpBackToTop);

    Vue.mixin(AjaxMixin);
    Vue.mixin(HelpersMixin);
    Vue.mixin(ValidationMixin);
    Vue.mixin(LocalisedVarsMixin);
    Vue.mixin(RecaptchaMixin);

    const defaultOptions = {
      compact: true,
      sidebar: true
    }

    Vue.prototype.$formFrameworkOptions = {...defaultOptions, ...options}

  }

}

export { BxpButton }
